const BASE_URL = "https://api.digitalrawalpindi.com";
//const BASE_URL = "https://localhost:4000";

export default BASE_URL;